<template>
    <div class="whole-step-container no-form-text">
        <card-container :title="$t('workorder_form_worker_info_title')">
            <a-form
                ref="formRef"
                :model="workerInfo"
                :rules="rules"
                :layout="formLayout"
            >
                <!-- 이름 필드 (왼쪽 1행 50%) -->
                <div class="step-1-customer issue-card-content">
                    <div class="left-container">
                        <a-form-item
                            name="name"
                            ref="name"
                            :colon="false"
                            :validate-status="'success'"
                            :help="''"
                        >
                            <template #label>
                                <row-with-label
                                    label-width="120px"
                                    :label-title="$t('workorder_form_name')"
                                    :is-required="false"
                                />
                            </template>
                            <a-input
                                :placeholder="$t('workorder_form_name_placeholder')"
                                :maxlength="50"
                                :value="workerInfo.name"
                                @input="handleWorkerNameChange"
                                type="text"
                            />
                        </a-form-item>
                    </div>
                    <div class="right-container">
                        <!-- 빈 공간 -->
                    </div>
                </div>
                <!-- 작업일자 + 보철 납품일 (2열) -->
                <div class="step-1-customer issue-card-content">
                    <div class="left-container">
                        <a-form-item
                            name="workDate"
                            ref="workDate"
                            :colon="false"
                            :validate-status="'success'"
                            :help="''"
                        >
                            <template #label>
                                <row-with-label
                                    label-width="120px"
                                    :label-title="$t('workorder_form_work_date')"
                                    :is-required="false"
                                />
                            </template>
                            <a-input
                                type="text"
                                inputmode="numeric"
                                placeholder="0000/00/00"
                                :maxlength="10"
                                :value="workDateInputValue"
                                @input="formatWorkDate"
                            />
                        </a-form-item>
                    </div>
                    <div class="right-container">
                        <a-form-item
                            name="prostheticDeliveryDate"
                            ref="prostheticDeliveryDate"
                            :colon="false"
                            :validate-status="'success'"
                            :help="''"
                        >
                            <template #label>
                                <row-with-label
                                    label-width="120px"
                                    :label-title="$t('workorder_form_prosthetic_delivery_date')"
                                    :is-required="true"
                                >
                                    <template #hint>
                                        <card-field-hint field="date" />
                                    </template>
                                </row-with-label>
                            </template>
                            <a-input
                                type="text"
                                inputmode="numeric"
                                placeholder="0000/00/00"
                                :maxlength="10"
                                :value="prostheticDeliveryDateInputValue"
                                @input="formatProstheticDeliveryDate"
                            />
                        </a-form-item>
                    </div>
                </div>
            </a-form>
            <div class="step-1-customer issue-card-content" style="padding-bottom: 20px;">
                <div class="left-container">
                    <div class="date-picker-wrap issue">
                        <div class="datepicker-item">
                            <div class="year-month-wrap">
                                <div class="year-wrap work-year-wrap">
                                    <button
                                        class="year-item"
                                        v-for="year in yearList"
                                        :key="year"
                                        :value="year"
                                        @click="handleWorkYearClick(year)"
                                        :class="{ selected: checkWorkYearSelected(year) }"
                                        :id="`work-year-${year}`"
                                    >
                                        {{ year }}
                                    </button>
                                </div>
                                <div class="month-wrap work-month-wrap">
                                    <button
                                        class="month-item"
                                        v-for="month in monthList"
                                        :key="month"
                                        :value="month"
                                        @click="handleWorkMonthClick(month)"
                                        :class="{ selected: checkWorkMonthSelected(month) }"
                                        :id="`work-month-${month}`"
                                    >
                                        {{ month }}
                                    </button>
                                </div>
                            </div>
                            <VueDatePicker
                                :select-text="$t('workorder_form_select')"
                                :cancel-text="$t('workorder_form_cancel')"
                                validate vertical
                                locale="ko-KR"
                                inline
                                text-input
                                inline-with-input
                                auto-apply
                                :month-change-on-scroll="false"
                                v-model="workerInfo.workDate"
                                format="yyyy/MM/dd"
                                @update:model-value="handleWorkDatePickerChange"
                            />
                        </div>
                    </div>
                </div>
                <div class="right-container">
                    <div class="date-picker-wrap issue">
                        <div class="datepicker-item">
                            <div class="year-month-wrap">
                                <div class="year-wrap delivery-year-wrap">
                                    <button
                                        class="year-item"
                                        v-for="year in yearList"
                                        :key="year"
                                        :value="year"
                                        @click="handleDeliveryYearClick(year)"
                                        :class="{ selected: checkDeliveryYearSelected(year) }"
                                        :id="`delivery-year-${year}`"
                                    >
                                        {{ year }}
                                    </button>
                                </div>
                                <div class="month-wrap delivery-month-wrap">
                                    <button
                                        class="month-item"
                                        v-for="month in monthList"
                                        :key="month"
                                        :value="month"
                                        @click="handleDeliveryMonthClick(month)"
                                        :class="{ selected: checkDeliveryMonthSelected(month) }"
                                        :id="`delivery-month-${month}`"
                                    >
                                        {{ month }}
                                    </button>
                                </div>
                            </div>
                            <VueDatePicker
                                :select-text="$t('workorder_form_select')"
                                :cancel-text="$t('workorder_form_cancel')"
                                validate vertical
                                locale="ko-KR"
                                inline
                                text-input
                                inline-with-input
                                auto-apply
                                :month-change-on-scroll="false"
                                v-model="workerInfo.prostheticDeliveryDate"
                                format="yyyy/MM/dd"
                                @update:model-value="handleDeliveryDatePickerChange"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </card-container>
    </div>
</template>

<script>
import CardContainer from './CardContainer.vue';
import RowWithLabel from '@/views/components/RowWithLabel';
import CardFieldHint from './CardFieldHint.vue';
import dayjs from 'dayjs';
import { oneBtnDialog } from '@/utils/utils';
import { issueUtils } from './utils/utils';

export default {
    name: 'WorkerInfoForm',
    components: {
        CardContainer,
        RowWithLabel,
        CardFieldHint,
    },
    emits: [
        'update:modelValue',
    ],
    data() {
        return {
            issueUtils: issueUtils(),
            yearList: [],
            monthList: [],
            workDateInputValue: '',
            prostheticDeliveryDateInputValue: '',
            rules: {
                name: [],
                workDate: [],
                prostheticDeliveryDate: [],
            },
        }
    },
    props: {
        windowInnerWidthGreaterThan1000: {
            type: Boolean,
            default: false,
        },
        modelValue: {
            type: Object,
            required: true,
        },
    },
    computed: {
        formLayout() {
            return this.windowInnerWidthGreaterThan1000 ? 'horizontal' : 'vertical';
        },
        workerInfo: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            }
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            await this.generateYearAndMonths();

            // 작업일자 기본값을 오늘 날짜로 설정
            const today = new Date();
            const year = today.getFullYear();
            const month = String(today.getMonth() + 1).padStart(2, '0');
            const day = String(today.getDate()).padStart(2, '0');
            const todayString = `${year}/${month}/${day}`;
            this.workerInfo.workDate = todayString;
            this.workDateInputValue = todayString;

            // 보철 납품일 기본값도 오늘 날짜로 설정
            this.workerInfo.prostheticDeliveryDate = todayString;
            this.prostheticDeliveryDateInputValue = todayString;

            this.scrollToSelectedWorkYear();
            this.scrollToSelectedWorkMonth();
            this.scrollToSelectedDeliveryYear();
            this.scrollToSelectedDeliveryMonth();

            this.generateRules();
        },

        generateRules() {
            this.rules = {
                name: [],
                workDate: [],
                prostheticDeliveryDate: [
                    {
                        required: true,
                        validator: this.validateProstheticDeliveryDate,
                        trigger: 'click'
                    }
                ],
            }
        },

        async validateProstheticDeliveryDate(_rule, value) {
            if (!this.workerInfo.prostheticDeliveryDate || this.prostheticDeliveryDateInputValue.length < 10) {
                await oneBtnDialog(this.$t('workorder_validation_prosthetic_delivery_required_title'), this.$t('workorder_validation_prosthetic_delivery_required_message'), false, this.$t('workorder_validation_confirm'));
                return Promise.reject(new Error(this.$t('workorder_validation_prosthetic_delivery_required_message')));
            }
            return Promise.resolve();
        },

        handleWorkerNameChange(event) {
            this.workerInfo.name = event.target.value;
        },

        // 날짜 입력 포맷 함수
        formatInputToDate(input) {
            const onlyNumbers = input.replace(/\D/g, ''); // 숫자만 추출

            if (onlyNumbers.length <= 4) {
                return onlyNumbers;
            } else if (onlyNumbers.length <= 6) {
                let year = onlyNumbers.slice(0, 4);
                let month = onlyNumbers.slice(4);

                // 월 검증
                if (parseInt(month, 10) > 12) {
                    month = '12';
                }

                return `${year}/${month}`;
            } else {
                let year = onlyNumbers.slice(0, 4);
                let month = onlyNumbers.slice(4, 6);
                let day = onlyNumbers.slice(6, 8);

                // 월과 일 검증
                if (parseInt(month, 10) > 12) {
                    month = '12';
                }
                if (parseInt(day, 10) > 31) {
                    day = '31';
                }

                return `${year}/${month}/${day}`;
            }
        },

        // 작업일자 포맷 함수
        formatWorkDate(event) {
            const result = this.formatInputToDate(event.target.value);
            event.target.value = result;
            this.workDateInputValue = result;
            if(result.length === 10) {
                this.workerInfo.workDate = result;

                this.scrollToSelectedWorkYear();
                this.scrollToSelectedWorkMonth();
            } else if(result.length === 0) {
                this.workerInfo.workDate = result;
            }
        },

        // 보철 납품일 포맷 함수
        formatProstheticDeliveryDate(event) {
            const result = this.formatInputToDate(event.target.value);
            event.target.value = result;
            this.prostheticDeliveryDateInputValue = result;
            if(result.length === 10) {
                this.workerInfo.prostheticDeliveryDate = result;

                this.scrollToSelectedDeliveryYear();
                this.scrollToSelectedDeliveryMonth();
            } else if(result.length === 0) {
                this.workerInfo.prostheticDeliveryDate = result;
            }
        },

        // 달력 날짜 선택 핸들러
        handleWorkDatePickerChange(date) {
            if (!date) {
                this.workerInfo.workDate = null;
                this.workDateInputValue = '';
                return;
            }
            const text = dayjs(date).format('YYYY/MM/DD');
            this.workerInfo.workDate = text;
            this.workDateInputValue = text;

            this.scrollToSelectedWorkYear();
            this.scrollToSelectedWorkMonth();
        },

        // 년/월 클릭 핸들러
        handleWorkYearClick(year) {
            if(!year) return;

            const { newDate, newFormattedDate } = this.issueUtils.handleYear(this.workerInfo.workDate, this.workDateInputValue, year);

            this.workerInfo.workDate = newDate;
            this.workDateInputValue = newFormattedDate;
        },

        handleWorkMonthClick(month) {
            if(!month || !this.workerInfo.workDate) return;

            const { newDate, newFormattedDate } = this.issueUtils.handleMonth(this.workerInfo.workDate, this.workDateInputValue, month);

            this.workerInfo.workDate = newDate;
            this.workDateInputValue = newFormattedDate;
            this.scrollToSelectedWorkMonth();
        },

        checkWorkYearSelected(year) {
            return this.issueUtils.checkIsYearSelected(year, this.workerInfo.workDate);
        },

        checkWorkMonthSelected(month) {
            return this.issueUtils.checkIsMonthSelected(month, this.workerInfo.workDate);
        },

        scrollToSelectedWorkYear() {
            const selectedYear = this.issueUtils.getSelectedDatePart(this.workerInfo.workDate, 'year');
            if (!selectedYear) return;
            const yearEl = document.querySelector(`#work-year-${selectedYear}`);
            if (!yearEl) return;
            const container = document.querySelector('.work-year-wrap');
            const containerHeight = container.clientHeight;
            const elementHeight = yearEl.clientHeight;
            container.scrollTop = yearEl.offsetTop - container.offsetTop + (elementHeight / 2) - (containerHeight / 2);
        },

        scrollToSelectedWorkMonth() {
            const selectedMonth = this.issueUtils.getSelectedDatePart(this.workerInfo.workDate, 'month');
            if (!selectedMonth) return;
            const monthEl = document.querySelector(`#work-month-${selectedMonth}`);
            if (!monthEl) return;
            const container = document.querySelector('.work-month-wrap');
            const containerHeight = container.clientHeight;
            const elementHeight = monthEl.clientHeight;
            container.scrollTop = monthEl.offsetTop - container.offsetTop + (elementHeight / 2) - (containerHeight / 2);
        },

        // 보철 납품일 관련 핸들러들
        handleDeliveryDatePickerChange(date) {
            if (!date) {
                this.workerInfo.prostheticDeliveryDate = null;
                this.prostheticDeliveryDateInputValue = '';
                return;
            }
            const text = dayjs(date).format('YYYY/MM/DD');
            this.workerInfo.prostheticDeliveryDate = text;
            this.prostheticDeliveryDateInputValue = text;

            this.scrollToSelectedDeliveryYear();
            this.scrollToSelectedDeliveryMonth();
        },

        handleDeliveryYearClick(year) {
            if(!year) return;

            const { newDate, newFormattedDate } = this.issueUtils.handleYear(this.workerInfo.prostheticDeliveryDate, this.prostheticDeliveryDateInputValue, year);

            this.workerInfo.prostheticDeliveryDate = newDate;
            this.prostheticDeliveryDateInputValue = newFormattedDate;
        },

        handleDeliveryMonthClick(month) {
            if(!month || !this.workerInfo.prostheticDeliveryDate) return;

            const { newDate, newFormattedDate } = this.issueUtils.handleMonth(this.workerInfo.prostheticDeliveryDate, this.prostheticDeliveryDateInputValue, month);

            this.workerInfo.prostheticDeliveryDate = newDate;
            this.prostheticDeliveryDateInputValue = newFormattedDate;
            this.scrollToSelectedDeliveryMonth();
        },

        checkDeliveryYearSelected(year) {
            return this.issueUtils.checkIsYearSelected(year, this.workerInfo.prostheticDeliveryDate);
        },

        checkDeliveryMonthSelected(month) {
            return this.issueUtils.checkIsMonthSelected(month, this.workerInfo.prostheticDeliveryDate);
        },

        scrollToSelectedDeliveryYear() {
            const selectedYear = this.issueUtils.getSelectedDatePart(this.workerInfo.prostheticDeliveryDate, 'year');
            if (!selectedYear) return;
            const yearEl = document.querySelector(`#delivery-year-${selectedYear}`);
            if (!yearEl) return;
            const container = document.querySelector('.delivery-year-wrap');
            if (!container) return;
            const containerHeight = container.clientHeight;
            const elementHeight = yearEl.clientHeight;
            container.scrollTop = yearEl.offsetTop - container.offsetTop + (elementHeight / 2) - (containerHeight / 2);
        },

        scrollToSelectedDeliveryMonth() {
            const selectedMonth = this.issueUtils.getSelectedDatePart(this.workerInfo.prostheticDeliveryDate, 'month');
            if (!selectedMonth) return;
            const monthEl = document.querySelector(`#delivery-month-${selectedMonth}`);
            if (!monthEl) return;
            const container = document.querySelector('.delivery-month-wrap');
            if (!container) return;
            const containerHeight = container.clientHeight;
            const elementHeight = monthEl.clientHeight;
            container.scrollTop = monthEl.offsetTop - container.offsetTop + (elementHeight / 2) - (containerHeight / 2);
        },

        generateYearAndMonths() {
            const currentYear = dayjs().year();
            for(let i = 1900; i <= currentYear; i++) {
                this.yearList.push(i);
            }
            for(let i = 1; i <= 12; i++) {
                this.monthList.push(i);
            }
        },

        // 부모 컴포넌트에서 호출할 검증 메서드
        async validateForm() {
            try {
                await this.$refs.formRef.validateFields(['prostheticDeliveryDate']);
            } catch (validationError) {
                return false;
            }
            return true;
        },

        // 부모 컴포넌트에서 호출할 데이터 가져오기 메서드
        getFormData() {
            return {
                name: this.workerInfo.name || '',
                workDate: this.workerInfo.workDate || '',
                prostheticDeliveryDate: this.workerInfo.prostheticDeliveryDate || ''
            };
        },
    }
}
</script>

<style lang="scss">
    @import './css/date-picker.scss';

    .whole-step-container {
        .dp__input_wrap {
            display: none;
        }
        .dp__outer_menu_wrap {
            width: 100%;
            margin-top: 10px;
        }
        .date-picker-wrap.issue .dp__menu {
            border: none;
        }
        .date-picker-wrap.issue .dp__calendar_header_separator {
            display: none;
        }
         .ant-form-item{
             margin-bottom: 0px;
         }
    }
</style>

<style scoped lang="scss">
@import './css/issue-certificate.scss';
@import './css/implant-abutment.scss';
</style>
